import { useQuery } from "@tanstack/react-query";
import { logPhonesApi } from "./axios";
import { ValidateCurrentToken, LogoutSystem } from "../../helpers";
import { AxiosError } from "axios";
import { DataI, ServiceResponseI } from "../../interfaces";
import { LoginControlI, PropsLogDataI } from "../../interfaces";

const getLogPhones = async ({
  pagination,
  sorting,
  globalFilter,
  dateFrom,
  dateTo,
}: PropsLogDataI): Promise<ServiceResponseI<DataI<LoginControlI>>> => {
  try {
    const validateToken = ValidateCurrentToken();
    if (!validateToken) throw new Error("TOKEN INVALIDO");

    const params = new URLSearchParams();
    params.append("page", (pagination!.pageIndex + 1).toString());
    params.append("limit", pagination!.pageSize.toString());
    params.append("search", globalFilter ?? "");
    params.append("sorting", JSON.stringify(sorting ?? []));
    if (dateFrom) params.append("dateFrom", dateFrom);
    if (dateTo) params.append("dateTo", dateTo);

    const { data } = await logPhonesApi.get<
      ServiceResponseI<DataI<LoginControlI>>
    >("", {
      params,
      headers: { Authorization: validateToken },
    });

    return data;
  } catch (err) {
    const obj = (err as AxiosError).response;
    if (obj?.status === 401) LogoutSystem();
    throw new Error((obj?.data as Error).message);
  }
};

export const useLogPhones = ({
  pagination,
  sorting,
  globalFilter,
  dateFrom,
  dateTo,
}: PropsLogDataI) => {
  const logPhonesQuery = useQuery(
    ["log-phones", { pagination, sorting, globalFilter, dateFrom, dateTo }],
    () =>
      getLogPhones({
        pagination,
        sorting,
        globalFilter,
        dateFrom,
        dateTo,
      }),
    {
      refetchOnWindowFocus: false,
      keepPreviousData: true,
    },
  );

  return { logPhonesQuery };
};
